module.exports = __webpack_public_path__ + "static/media/ic_success.7bebcb83.svg";